import { relativeFromNow } from '../../util/time';

export function Footer({
  deviceId,
  firmwareVersion,
  lastReportedAt,
}: {
  deviceId?: string | undefined;
  firmwareVersion?: string | undefined;
  lastReportedAt?: string | undefined;
}) {
  if (!deviceId) return null;
  return (
    <footer className="muted" style={{ marginTop: 'var(--sp-7)', paddingTop: 'var(--sp-3)', borderTop: '1px solid var(--border)', fontSize: 'var(--fs-xs)', display: 'flex', justifyContent: 'space-between', gap: 'var(--sp-3)' }}>
      <span>
        {deviceId}
        {firmwareVersion && firmwareVersion !== 'unknown' && (
          <> · fw <span className="tabular">{firmwareVersion}</span></>
        )}
      </span>
      {lastReportedAt && <span>Last update {relativeFromNow(lastReportedAt)}</span>}
    </footer>
  );
}
